import styled from 'styled-components';
import { Flex } from 'utils/style';

import TimePickersContainer from 'components/form/TimePickers/container';

export default styled(TimePickersContainer)`
  ${Flex.row};

  .fieldContainer {
    flex: 1;
    position: relative;
  }

  .fieldContainer + .fieldContainer {
    left: -1px;
  }

  .fieldContainer > div > :after {
    padding-top: 1.44em;
  }

  .floating-large {
    width: auto;
  }

  .suggested-aclaration {
    overflow: hidden;
    white-space: nowrap;
    padding-left: 10px;
    color: #94a6b8;
  }
`;
